import { Pipe, PipeTransform } from '@angular/core';
import { Visits } from '@types-lib';
import { Order } from '../../../../../angularJs/src/app/prototypes/order.prototype';

@Pipe({
  name: 'humanisedStatus',
  standalone: true,
  pure: false,
})
export class HumanisedStatusPipe implements PipeTransform {
  transform(order: Visits.VisitOrder): string | null {
    if (order) {
      const orderInstance = new Order(order);
      if (!orderInstance.currentUser) {
        return '';
      }
      if (orderInstance.isLocked()) {
        return `Locked by Dr. ${order.locked_by.lastname}`;
      }
      try {
        return orderInstance.getStatus();
      } catch (e) {
        throw new Error(`'We do not know this status! Please add it to Constants.': ${e}`);
      }
    }
    return '';
  }
}
